import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Invoice } from './invoice.model';
import { DateUtils } from 'ng-jhipster';
import { DateUtilities } from '../../shared';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class InvoiceService extends AbstractEntityService {

    protected resourceUrl = 'api/invoices';
    protected resourceByStudentUrl = 'api/invoices/by-student';
    private resourceSearchUrl = 'api/_search/invoices';
    protected resourceCountUrl = 'api/_search/count/invoices';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(invoice: Invoice): Observable<Invoice> {
        let copy: Invoice = Object.assign({}, invoice);
        copy.dateIssued = this.dateUtils
            .convertLocalDateToServer(invoice.dateIssued);
        copy.dueDate = this.dateUtils
            .convertLocalDateToServer(invoice.dueDate);
        return this.http.post<Invoice>(this.resourceUrl, copy).map((res: Invoice) => {
            return res;
        });
    }

    update(invoice: Invoice): Observable<Invoice> {
        let copy: Invoice = Object.assign({}, invoice);
        copy.dateIssued = this.dateUtils
            .convertLocalDateToServer(invoice.dateIssued);
        copy.dueDate = this.dateUtils
            .convertLocalDateToServer(invoice.dueDate);
        return this.http.put<Invoice>(this.resourceUrl, copy).map((res: Invoice) => {
            return res;
        });
    }

    createByStudent(invoice: Invoice): Observable<Invoice> {
        let copy: Invoice = Object.assign({}, invoice);
        copy.dateIssued = this.dateUtils
            .convertLocalDateToServer(invoice.dateIssued);
        copy.dueDate = this.dateUtils
            .convertLocalDateToServer(invoice.dueDate);
        return this.http.post<Invoice>(this.resourceByStudentUrl, copy).map((res: Invoice) => {
            return res;
        });
    }

     updateByStudent(invoice: Invoice): Observable<Invoice> {
        let copy: Invoice = Object.assign({}, invoice);
        copy.dateIssued = this.dateUtils
            .convertLocalDateToServer(invoice.dateIssued);
        copy.dueDate = this.dateUtils
            .convertLocalDateToServer(invoice.dueDate);
        return this.http.put<Invoice>(this.resourceByStudentUrl, copy).map((res: Invoice) => {
            return res;
        });
    }

    find(id: number): Observable<Invoice> {
        return this.http.get<Invoice>(`${this.resourceUrl}/${id}`).map((res: Invoice) => {
            let jsonResponse = res;
            jsonResponse.dateIssued = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateIssued);
            jsonResponse.dueDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dueDate);

            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<Invoice[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Invoice[]>>(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<Invoice[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Invoice[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Invoice[]>) => this.convertResponse(res))
            ;
    }

    downloadPdf(url: string): Observable<Blob> {
        return this.http.get(url, {
            responseType: 'blob',
            headers: new HttpHeaders({
                'Accept': 'application/pdf'
            })
        });
    }

    generatePdf(invoice: Invoice): Observable<Blob> {
        let copy: Invoice = Object.assign({}, invoice);

        if (DateUtilities.isNgbDateStruct(copy.dateIssued)) {
            copy.dateIssued = this.dateUtils
                .convertLocalDateToServer(invoice.dateIssued);
        }

        if (DateUtilities.isNgbDateStruct(copy.dueDate)) {
            copy.dueDate = this.dateUtils
                .convertLocalDateToServer(invoice.dueDate);
        }

        return this.http.post(this.resourceUrl + '/generate-pdf',
                            copy,
                            {
                                responseType: 'blob',
                                headers: new HttpHeaders({
                                    'Accept': 'application/pdf'
                                })
                             });
    }

    private convertResponse(res: HttpResponse<Invoice[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateIssued = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].dateIssued);

            jsonResponse[i].dueDate = this.dateUtils
            .convertLocalDateFromServer(jsonResponse[i].dueDate);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice.service.ts